import React, { useState, FC, useEffect } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { setUserToLocalStorage } from "../../../../utils/functions/localStorageManager";
import { User } from "../../../../types";
import { productNoFocusState } from "../../../../states/variableState";

type Props = {
  fullWidth: boolean;
  label: string;
  multiline: boolean;
  required: boolean;
  rows: number;
  type: string;
  InputProps?: TextFieldProps["InputProps"];
  placeholder: string;
  disabled: boolean;
  colorMode: string;
  value: string;
  handleChange: (value: string) => void;
  height?: string; // 新しく追加
  width?: string; // 新しく追加
  fontSize?: string; // 新しく追加
};
const TextInput: FC<Props> = (props) => {
  const { value, handleChange, colorMode, width, height, fontSize } = props;
  const [user, setUser] = useRecoilState(userState);
  // const [productNo, setProductNo] = useState(user.initialParameters.productNo);
  const theme = useTheme();

  //   setProductNo(user.initialParameters.productNo);
  // }, [user.initialParameters.productNo]);
  return (
    <TextField
      // color={"#0adcc0"}
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={value}
      type={props.type}
      onChange={(e) => handleChange(e.target.value)}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        ...props.InputProps,
        endAdornment: props.InputProps ? (
          // <InputAdornment position="start">
          //   <div
          //     style={{
          //       backgroundColor: "#0adcc0",
          //       width: "36px",
          //       height: "20px",
          //       paddingLeft: "6px",
          //       borderRadius: "5px",
          //       cursor: "pointer",
          //     }}
          //     onClick={props.onClick}
          //   >
          //     <SearchIcon />
          //   </div>
          // </InputAdornment>
          <></>
        ) : null,
        sx: {
          "& .MuiInput-underline:before": {
            borderBottomColor:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light, // 通常時の下線の色
          },
          "& .MuiInput-underline:after": {
            borderBottomColor:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light, // フォーカス時の下線の色
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: `${
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light
            }!important`, // ホバー時の下線の色
          },
          "& .MuiInput-underline": {
            borderBottomColor: `${
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light
            }!important`, // ホバー時の下線の色
          },
          // 他のスタイルもここに追加できます
        },
      }}
      sx={{
        margin: "0 0",

        "&&&": {
          // color: "blue",
          width: width || "78px", // widthがpropsで渡されている場合はそれを適用
          height: height || "28px", // heightがpropsで渡されている場合はそれを適用
          backgroundColor:
            colorMode === "light"
              ? theme.palette.backColor.main
              : theme.palette.backColor.dark,
          // padding: "5px 10px 2px 10px",
          borderRadius: "5px",
        },
        "& label": {
          padding: "10px",
          color:
            colorMode === "light"
              ? theme.palette.foreColor.main
              : theme.palette.foreColor.light,
          fontSize: fontSize || "18px", // fontSizeがpropsで渡されている場合はそれを適用
        },
        "& svg": {
          // marginTop: "5px",
          color: "#f0f2f5",
        },
        "& input": {
          width: width || "78px", // widthがpropsで渡されている場合はそれを適用
          height: "28px", // heightがpropsで渡されている場合はそれを適用
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "2px",
          paddingLeft: "0px",
          fontSize: "16px",
          color:
            colorMode === "light"
              ? theme.palette.foreColor.main
              : theme.palette.foreColor.light,
          fontWeight: "700",
          "&:hover": {
            color:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light,
          },
          "&:focus": {
            color:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light,
          },
          //   backgroundColor: "black",
        },
        "& .MuiSvgIcon-root": {
          color: "#f0f2f5",
        },
        "& .MuiInputBase-input": {
          fontSize: fontSize || "16px", // fontSizeがpropsで渡されている場合はそれを適用
          color:
            colorMode === "light"
              ? theme.palette.foreColor.main
              : theme.palette.foreColor.light,
          fontWeight: "700",
        },
        // InputPropsで指定したスタイル以外にもここで追加できます
      }}
    />
  );
};
export default TextInput;
